import { connect } from 'react-redux';
import { NText } from '@fttb/common/components';
import { getTariffDescription } from "../../../../store/blocks/tariffs/tariffSelectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getTariffDescription(state),
    color: 'grey60',
    size: 'size5-r-l'
  };
};
export var TariffDescription = connect(mapStateToProps)(NText);